( function () {
	const activeDot = 'active', disabledBtns = 'disabled';

	document.addEventListener( 'DOMContentLoaded', initAllCarousels );

	// fired by facilities-ajax.js
	document.body.addEventListener( 'facility-result-rendered', initAllCarousels );

	function initAllCarousels() {
		const carouselEles = document.querySelectorAll( '.scroll-carousel' );
		if( !carouselEles ) { return; }

		Array.from( carouselEles ).forEach( carouselEle => {
			initCarousel.apply( carouselEle );
		} );
	}

	function initCarousel() {
		const carouselEle = this;

		const slideScrollerEle = carouselEle.querySelector( '.scroll-carousel__container' );
		if( !slideScrollerEle ) { 
			// either single slide (no controls), or waiting for it to load
			carouselEle.addEventListener( 'scroll-carousel-rendered', initCarousel );
			return;
		}

		slideScrollerEle.removeEventListener( 'scroll', scrollHandler );
		slideScrollerEle.addEventListener( 'scroll', scrollHandler );

		const nextEle = carouselEle.querySelector( '.scroll-carousel__next' );
		if( nextEle ) { // not a single slide situation
			nextEle.removeEventListener( 'click', nextSlide );
			nextEle.addEventListener( 'click', nextSlide );
		}

		const prevEle = carouselEle.querySelector( '.scroll-carousel__prev' );
		if( prevEle ) { // not a single slide situation
			prevEle.removeEventListener( 'click', prevSlide );
			prevEle.addEventListener( 'click', prevSlide );
		}

		Array.from( carouselEle.querySelectorAll( '.scroll-carousel__dots li button' ) ).forEach( dot => {
			dot.removeEventListener( 'click', dotScroll );
			dot.addEventListener( 'click', dotScroll );
		} );

		updateIndicators( carouselEle );
		updateArrows( carouselEle );
	}

	function nextSlide( e ) {
		e.preventDefault();
		const carouselEle = e.target.closest( '.scroll-carousel' );
		const dotEles = carouselEle.querySelectorAll( '.scroll-carousel__dots li' );
		const nextDotIndex = parseInt( carouselEle.dataset.currIndex ) + 1;

		if( dotEles[ nextDotIndex ] ) {
			scrollToSlide( carouselEle, nextDotIndex );
		}
	}

	function prevSlide( e ) {
		e.preventDefault();
		const carouselEle = e.target.closest( '.scroll-carousel' );
		const dotEles = carouselEle.querySelectorAll( '.scroll-carousel__dots li' );
		const prevDotIndex = parseInt( carouselEle.dataset.currIndex ) - 1;

		if( dotEles[ prevDotIndex ] ) {
			scrollToSlide( carouselEle, prevDotIndex );
		}
	}

	function dotScroll ( e ) {
		e.preventDefault();
		const carouselEle = e.target.closest( '.scroll-carousel' );
		const carouselDotEles = carouselEle.querySelectorAll( '.scroll-carousel__dots li' );
		const dotEle = e.target.closest( '.scroll-carousel__dots li' );
		const index = Array.from( carouselDotEles ).findIndex( item => item === dotEle );
		scrollToSlide( carouselEle, index, 'auto' );
	}

	function scrollHandler( e ) {
		const carouselEle = e.target.closest( '.scroll-carousel' );
		updateIndicators( carouselEle, getCurrentSlide( carouselEle ) );
		updateArrows( carouselEle );
	}

	function scrollToSlide( carouselEle, index, behavior = 'smooth' ) {
		const slideScrollerEle = carouselEle.querySelector( '.scroll-carousel__container' );
		const slideEles = slideScrollerEle.children;
		const goToIndex = Math.max( Math.min( index, slideEles.length - 1 ), 0 ); // make sure the index is within the bounds of the slideshow

		if ( parseInt( carouselEle.dataset.currIndex ) == goToIndex ) { return; } // bail - no need to update the DOM

		const origScroll = slideScrollerEle.scrollLeft - slideScrollerEle.offsetLeft;
		const scrollTo = slideEles[ goToIndex ].offsetLeft - slideScrollerEle.offsetLeft;

		const forcedScrollHandler = function( e ) {
			const currScroll = e.target.scrollLeft - e.target.offsetLeft;
			const allTheWayRight = Math.abs( e.target.scrollWidth - ( currScroll + e.target.clientWidth ) ) <= 1; // 1px fudge factor
			// all the way to the right or scrolling left and made it to the goal or scrolling right and made it to the goal
			const doneScrolling = allTheWayRight || ( origScroll >= scrollTo && currScroll <= scrollTo ) || ( origScroll < scrollTo && currScroll >= scrollTo );
			if( doneScrolling ) {
				e.target.removeEventListener( 'scroll', forcedScrollHandler );
				e.target.addEventListener( 'scroll', scrollHandler );
			}

			if( allTheWayRight ) {
				// update to make sure it's indicative of the last slide (not the first one to the left that's shown)
				updateIndicators( carouselEle, e.target.children.length - 1 );
				updateArrows( carouselEle );
			}
		};

		// stop listening for the user scroll while we're scrolling in code
		slideScrollerEle.removeEventListener( 'scroll', scrollHandler );
		slideScrollerEle.addEventListener( 'scroll', forcedScrollHandler );
		
		slideScrollerEle.scrollTo( { top: 0, left: scrollTo, behavior: behavior } );

		updateIndicators( carouselEle, index );
		updateArrows( carouselEle );
	}

	function getCurrentSlide( carouselEle ) {
		const slideScrollerEle = carouselEle.querySelector( '.scroll-carousel__container' );
		const slideEles = slideScrollerEle.children;
		const scrollPos = Math.ceil( slideScrollerEle.scrollLeft );
		const containerOffset = Math.floor( slideScrollerEle.offsetLeft );

		let index = 0;

		Array.from( slideEles ).forEach( ( slideEle, i ) => {
			const slidePos = Math.floor( slideEle.offsetLeft - containerOffset );
			if( slidePos <= scrollPos ) {
				index = i;
			} else {
				return false; // bail out, we've passed the scroll position
			}
		} );

		const lastSlide = slideEles[slideEles.length - 1];
		const distanceFromRightEdge = ( scrollPos + carouselEle.clientWidth ) - ( ( lastSlide.offsetLeft - containerOffset ) + lastSlide.clientWidth );
		if( distanceFromRightEdge <= 1 && distanceFromRightEdge >= -1 ) { // 1px fudge factor to account for rounding errors
			index = slideEles.length - 1;
		}

		return index;
	}

	function updateIndicators( carouselEle, index ) {
		if ( typeof index == 'undefined' ) {
			index = 0;
		}

		if ( parseInt( carouselEle.dataset.currIndex ) == index ) { return; } // bail - no need to update the DOM

		const carouselDotEles = carouselEle.querySelectorAll( '.scroll-carousel__dots li' );
		const dotEle = carouselDotEles[ index ];

		if( dotEle ) {
			const activeDotEle = carouselEle.querySelector( '.scroll-carousel__dots li .' + activeDot );
			if( activeDotEle ) { activeDotEle.classList.remove( activeDot ); }

			dotEle.querySelector( 'button' ).classList.add( activeDot );
		}


		carouselEle.dataset.currIndex = index;
	}

	function updateArrows( carouselEle ) {
		const slideScrollerEle = carouselEle.querySelector( '.scroll-carousel__container' );
		const slideEles = slideScrollerEle.children;
		const nextEle = carouselEle.querySelector( '.scroll-carousel__next' );
		const prevEle = carouselEle.querySelector( '.scroll-carousel__prev' );
		const currIndex = parseInt( carouselEle.dataset.currIndex );
		
		if( !nextEle ) { return; } // single slide

		if( currIndex >= slideEles.length - 1 ) {
			nextEle.classList.add( disabledBtns );
		} else if( nextEle.classList.contains( disabledBtns ) ) {
			nextEle.classList.remove( disabledBtns );
		}

		if( currIndex <= 0 ) {
			prevEle.classList.add( disabledBtns );
		} else if( prevEle.classList.contains( disabledBtns ) ) {
			prevEle.classList.remove( disabledBtns );
		}
	}
} )();
